import CONSTANTS from '@/constants'

const { EXTENSIONS } = CONSTANTS

export const extensionsHydratation = extensionsCollection => {
  extensionsCollection.forEach(extension => {
    extension.product_type = 'extension'
    switch (extension.merchant_id) {
      case EXTENSIONS.EXAM_EXTENSION:
        extension.name = '90 Day Voucher Extension'
        extension.description =
          'Your INE Security Exam Voucher will be extended 90 days from the current expiration. You must purchase the exam voucher extension before your voucher has expired. Voucher extension will be processed to your account within 2 business days.'
        break
      default:
        break
    }
  })
}
